// Presence status -> the avatar ring class and the label key. The ring
// keeps the existing .Online glow (App.css) and recolours it for idle/dnd.
export const PRESENCE_CHOICES = ['online', 'idle', 'dnd', 'invisible'];

export function presenceClass(status) {
  if (status === 'idle') return 'Online Idle';
  if (status === 'dnd') return 'Online Dnd';
  if (status === 'online') return 'Online';
  return '';
}

export const presenceLabelKey = (status) => `presence.${status || 'offline'}`;
